export default __webpack_public_path__ + "static/media/logo_jnj.46dc49c0.svg";